export default __webpack_public_path__ + "static/media/ic-website-dark.672bdd6b.svg";